// Wrapper class for saving/loading/clearing the landlord application data
import merge from "lodash.merge";

export class LandlordApplicationSaveLoad {
  constructor(vlf) {
    this.vlf = vlf;
  }

  // wrapper for "load" that checks for old records that are no longer valid
  async load() {
    let dataObject = await this.vlf.getItem(storageKey);

    // return null if nullish
    if (dataObject == null) {
      return null;
    }

    // invalidate stored data if too old
    if (!this.timestampIsValid(dataObject.lastUpdated)) {
      await this.clear();
      return null;
    }

    return dataObject;
  }

  // Wrapper to save, accepts an object and merges with the schema
  async save(objectToMerge) {
    let dataObject = await this.vlf.getItem(storageKey);

    // Check that dataobject is valid
    if (dataObject === null || !this.timestampIsValid(dataObject.lastUpdated)) {
      dataObject = { ...schema };
    }

    // merge fields
    dataObject = merge(dataObject, objectToMerge);

    dataObject.lastUpdated = Date.now();
    await this.vlf.setItem(storageKey, dataObject);
  }

  // Checks if timestamp of record is valid (less than 30 days ago)
  timestampIsValid(timestampInMs) {
    const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
    return Date.now() - timestampInMs < thirtyDaysInMs;
  }

  // Wrapper to clear cache
  async clear() {
    await this.vlf.removeItem(storageKey);
  }
}

// Expected schema for saving/loading
const schema = {
  contactData: undefined,
  idDocument: undefined,
  race: undefined,
  ethnicity: undefined,
  gender: undefined,
  minority: undefined,
  numOfProperties: undefined,
  propertyManager: undefined,
  propertyList: undefined,
  lastUpdated: undefined
};

// key used for storage
const storageKey = "rif-landlord-profile";
